import { Box, IconButton, TextField, Button, Link } from '@material-ui/core';
import React, { useContext } from 'react';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { GenericSnackBarContext } from '../../../components/context/GenericSnakBarContextProvider';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { resetPwd } from '../ForgetPwdStore/forgetPwdSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const validate = (values) => {
  const errors = {};
  const { password, reEntPassword } = values;

  if (!password) {
    errors.password = '**This Field is required';
  } else if (password.toString().length < 5) {
    errors.password = 'Password can not be less than 5 characters';
  }
  if (!reEntPassword) {
    errors.reEntPassword = '**This Field is required';
  } else if (password.toString().length < 5) {
    errors.reEntPassword = 'Password can not be less than 5 characters';
  }
  if (password !== reEntPassword) {
    errors.reEntPassword = 'Incorrect combination. Re-type your password again';
  }

  return errors;
};

function ResetPassword({ email, otpValue }) {
  const dispatch = useDispatch();
  const { ErrorToast } = useContext(GenericSnackBarContext);

  const formik = useFormik({
    initialValues: {
      showPassword: false,
      showReEntPassword: false,
      password: '',
      reEntPassword: '',
    },
    onSubmit: (values) => {
      const { password, reEntPassword } = values;
      dispatch(
        resetPwd({
          email: email,
          password: password,
          reEntPassword: reEntPassword,
          otp: otpValue,
        })
      )
        .then(unwrapResult)
        .then((result) => {
          window.location.href = window.location.origin;
        })
        .catch((error) => {
          ErrorToast(error.message);
        });
    },
    validate,
  });

  const handleShowPassword = () => {
    formik.setFieldValue('showPassword', !formik.values.showPassword);
  };
  const handleShowReEntPassword = () => {
    formik.setFieldValue('showReEntPassword', !formik.values.showReEntPassword);
  };

  const { password, reEntPassword } = formik.values;

  return (
    <Box mt={-3}>
      <TextField
        fullWidth
        variant="outlined"
        required
        value={password}
        placeholder="Your password"
        label="Enter your password"
        onChange={formik.handleChange}
        type={formik.values.showPassword ? 'text' : 'password'}
        name={'password'}
        onBlur={formik.handleBlur}
        error={formik.touched.password && formik.errors.password !== ''}
        helperText={formik.touched.password ? formik.errors.password : ''}
        InputProps={{
          endAdornment: (
            <IconButton
              id={'Pwd'}
              type="checkbox"
              aria-label="toggle password visibility"
              value={formik.values.showPassword}
              onClick={handleShowPassword}>
              {formik.values.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          ),
        }}
      />
      <Box mt={5} />
      <TextField
        fullWidth
        variant="outlined"
        required
        value={reEntPassword}
        placeholder="Set password"
        label="Re-enter password*"
        onChange={formik.handleChange}
        type={formik.values.showReEntPassword ? 'text' : 'password'}
        name={'reEntPassword'}
        onBlur={formik.handleBlur}
        error={
          formik.touched.reEntPassword && formik.errors.reEntPassword !== ''
        }
        helperText={
          formik.touched.reEntPassword ? formik.errors.reEntPassword : ''
        }
        InputProps={{
          endAdornment: (
            <IconButton
              id={'reEntPwd'}
              type="checkbox"
              aria-label="toggle reEntpassword visibility"
              value={formik.values.showReEntPassword}
              onClick={handleShowReEntPassword}>
              {formik.values.showReEntPassword ? (
                <Visibility />
              ) : (
                <VisibilityOff />
              )}
            </IconButton>
          ),
        }}
      />
      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={formik.handleSubmit}>
          Reset Password
        </Button>
        <Box mt={2} />
        <Link href="/signin">
          <Button variant="outlined" color="primary" fullWidth>
            Return to Sign in
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default ResetPassword;
